PJQ.views.settings.FinanceCoreFieldSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Finance-Core-Fields')
    },
    events: {
        'click .cb-visible': 'isVisibleChanged',
        'click .cb-required': 'isRequiredChanged',
    },
    beforeFirstRender: function () {
        let fnRender = _.bind(function(fillFields){
            _.each(fillFields, _.bind(function (field, index) {
                let matchField = this.collection.findWhere({fieldName: field.fieldName});
                if (matchField == null) {
                    this.collection.add(_.defaults(field, {
                        isVisible: true,
                        isRequired: false,
                        sortOrder: index,
                        canContactEdit: field.canEdit !== false
                    }));
                }
                else {
                    matchField.set({
                        name: field.name,
                        sortOrder: index,
                        canContactEdit: field.canEdit !== false
                    });
                }
            }, this));

            this.render();
        }, this);
        if(this.options.context){
            switch (this.options.context){
                case 'primecontracts':
                    PJQ.app.session.fetchPrimeContractFieldSettings(_.bind(function(fields) {
                        this.collection = fields;
                        fnRender(PJQ.constants.financeCoreFields.primeContacts.primeContract);
                    }, this));
                    break;
                case 'commitments':
                    PJQ.app.session.fetchCommitmentFieldSettings(_.bind(function(fields) {
                        this.collection = fields;
                        fnRender(PJQ.constants.financeCoreFields.commitments.commitment);
                    }, this));
                    break;
                case 'commitmentchangeorders':
                    PJQ.app.session.fetchCommitmentChangeOrderFieldSettings(_.bind(function(fields) {
                        this.collection = fields;
                        fnRender(PJQ.constants.financeCoreFields.commitments.changeOrder);
                    }, this));
                    break;
                case 'primecontractchangeorders':
                    PJQ.app.session.fetchPrimeContractChangeOrderFieldSettings(_.bind(function(fields) {
                        this.collection = fields;
                        fnRender(PJQ.constants.financeCoreFields.primeContacts.changeOrder);
                    }, this));
                    break;
                case 'receivableinvoices':
                    PJQ.app.session.fetchReceivableInvoiceFieldSettings(_.bind(function(fields) {
                        this.collection = fields;
                        fnRender(PJQ.constants.financeCoreFields.invoices.receivableInvoice);
                    }, this));
                    break;
                case 'payableinvoices':
                    PJQ.app.session.fetchPayableInvoiceFieldSettings(_.bind(function(fields) {
                        this.collection = fields;
                        fnRender(PJQ.constants.financeCoreFields.invoices.payableInvoice);
                    }, this));
                    break;
                case 'directcosts':
                    PJQ.app.session.fetchDirectCostFieldSettings(_.bind(function(fields) {
                        this.collection = fields;
                        fnRender(PJQ.constants.financeCoreFields.directCosts.directCost);
                    }, this));
                    break;
            }
        }
    },
    afterRender: function () {
        if (this.collection == null || !this.collection.isFetched) {
            return;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".field-table"),
            data: this.collection.models,
            isHideSearch: true,
            paging: false,
            rowId: "cid",
            order: [0, 'asc'],
            columns: [
                {
                    "title": "",
                    "data": "attributes.sortOrder",
                    "visible": false
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": false
                },
                {
                    "title": "Visible",
                    "data": "attributes.isVisible",
                    "orderable": false,
                    "render": function (data, type, row) {
                        let contactEdit = row.get('canContactEdit') !== false;
                        return '<div class="pretty p-switch" ' + (contactEdit ? '' : 'title="This field is never visible to contacts"') + '><input ' + (contactEdit ? '' : 'disabled') + ' type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-visible"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>';
                    }
                },
                {
                    "title": "Required",
                    "data": "attributes.isRequired",
                    "orderable": false,
                    "render": function (data, type, row) {
                        let contactEdit = row.get('canContactEdit') !== false;
                        return '<div class="pretty p-switch" ' + (contactEdit ? '' : 'title="This field is never visible to contacts"') + '><input ' + (contactEdit ? '' : 'disabled') + ' type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-required"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>';
                    }
                }
            ]
        });
    },
    isVisibleChanged: function (e) {
        let $target = $(e.currentTarget),
            $row = $target.closest('tr'),
            row = this.dataTable.getRow($row),
            setting = row.data(),
            enabled = $target.prop('checked');
        setting.set('isVisible', enabled);

        if (!enabled) {
            // if the field is made invisible to contacts
            // it must be made not required for contacts
            setting.set('isRequired', false);
        }

        setting.queueSave();
        this.dataTable.refresh();
    },
    isRequiredChanged: function (e) {
        let $target = $(e.currentTarget),
            $row = $target.closest('tr'),
            row = this.dataTable.getRow($row),
            setting = row.data();
        setting.set('isRequired', $target.prop('checked'));
        if(!setting.get('isVisible') && $target.prop('checked')){
            setting.set('isVisible', true);
        }

        setting.queueSave();
        this.dataTable.refresh();
    }
});